"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _classnames = _interopRequireDefault(require("classnames"));
var _reactStripeJs = require("@stripe/react-stripe-js");
var _utils = require("../../utils");
var _ = require("./..");
var _components = require("../../components");
var _StripeCard = _interopRequireDefault(require("./components/StripeCard"));
require("./StripePaymentForm.less");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var defaultStyle = {
  base: {
    color: '#497265',
    fontFamily: "'CentraNo1', 'Roboto', sans-serif",
    fontSmoothing: 'antialiased',
    fontSize: '16px',
    '::placeholder': {
      color: 'transparent'
    }
  },
  invalid: {
    color: '#333'
  }
};
var StripePaymentForm = function StripePaymentForm(_ref) {
  var _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? _lodash.noop : _ref$onChange,
    _ref$onSubmit = _ref.onSubmit,
    onSubmit = _ref$onSubmit === void 0 ? _lodash.noop : _ref$onSubmit,
    className = _ref.className,
    brand = _ref.brand,
    existingCardLast4 = _ref.existingCardLast4,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? _utils.StripeCheckoutModes.Card : _ref$mode,
    submitText = _ref.submitText,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus,
    _ref$showError = _ref.showError,
    showError = _ref$showError === void 0 ? false : _ref$showError,
    _ref$managePaymentTex = _ref.managePaymentText,
    managePaymentText = _ref$managePaymentTex === void 0 ? 'Use existing payment method' : _ref$managePaymentTex,
    _ref$hideManagePaymen = _ref.hideManagePaymentButton,
    hideManagePaymentButton = _ref$hideManagePaymen === void 0 ? false : _ref$hideManagePaymen,
    _ref$hideSubtitle = _ref.hideSubtitle,
    hideSubtitle = _ref$hideSubtitle === void 0 ? false : _ref$hideSubtitle;
  var _useState = (0, _react.useState)(!!existingCardLast4),
    _useState2 = _slicedToArray(_useState, 2),
    cardComplete = _useState2[0],
    setCardComplete = _useState2[1];
  var _useState3 = (0, _react.useState)(!!existingCardLast4),
    _useState4 = _slicedToArray(_useState3, 2),
    isApplyExistingCard = _useState4[0],
    setIsApplyExistingCard = _useState4[1];
  var elements = (0, _reactStripeJs.useElements)();
  var getCard = function getCard() {
    return mode === _utils.StripeCheckoutModes.Card ? elements === null || elements === void 0 ? void 0 : elements.getElement(_reactStripeJs.CardElement) : elements === null || elements === void 0 ? void 0 : elements.getElement(_reactStripeJs.CardNumberElement);
  };
  var onFormChange = function onFormChange(e, elementName, complete) {
    setCardComplete(complete);
    onChange(getCard(), {
      e: e,
      elementName: elementName,
      complete: complete
    });
  };
  var onChangeApplyExistingCard = function onChangeApplyExistingCard() {
    var apply = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    setIsApplyExistingCard(apply);

    // execute when CardElement is mounted to pass it correctly to the callback
    setTimeout(function () {
      onFormChange(null, null, apply);
    }, 50);
  };
  (0, _react.useEffect)(function () {
    onChangeApplyExistingCard(!!existingCardLast4);
  }, [existingCardLast4]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('StripePaymentForm', className, {
      'StripePaymentForm--existing-card': isApplyExistingCard
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ant-form-item-children card-element"
  }, !hideSubtitle && /*#__PURE__*/_react.default.createElement("p", {
    className: "text-black mb-[8px]"
  }, isApplyExistingCard ? 'Saved credit card' : ''), isApplyExistingCard ? /*#__PURE__*/_react.default.createElement("div", {
    className: "card-mask-wrapper"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "card-mask"
  }, /*#__PURE__*/_react.default.createElement(_.CardBrandIcon, {
    brand: brand
  }), /*#__PURE__*/_react.default.createElement(_.CardMask, {
    last4: existingCardLast4
  })), /*#__PURE__*/_react.default.createElement(_components.IconButton, {
    onClick: function onClick() {
      onChangeApplyExistingCard(false);
    },
    icon: "edit-pencil-filled",
    size: 30,
    className: "text-grey-40"
  })) : /*#__PURE__*/_react.default.createElement(_StripeCard.default, {
    mode: mode,
    onChange: onFormChange,
    style: defaultStyle,
    autoFocus: autoFocus,
    showError: showError
  }), !hideManagePaymentButton && !isApplyExistingCard && !!existingCardLast4 && /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-[16px]"
  }, submitText && /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    size: "small",
    className: "mr-[16px]",
    onClick: function onClick() {
      onSubmit(getCard());
    },
    disabled: !isApplyExistingCard && !cardComplete
  }, submitText), /*#__PURE__*/_react.default.createElement(_components.TextButton, {
    size: "small",
    onClick: function onClick() {
      return onChangeApplyExistingCard(true);
    }
  }, managePaymentText))));
};
var _default = StripePaymentForm;
exports.default = _default;